<template>
        <div>
          <MultipleChoice :options="items"
                          :value="singleValue"
                          @input="emitSingleValue($event)"
                          value-key="value"
                          label-key="text"
          ></MultipleChoice>
          <div v-if="questionresponse.example" class="pa-2">
            <v-alert v-if="example==='incorrect'" type="error">{{incorrectContent}}</v-alert>
            <v-alert v-if="example==='correct'" type="success">{{correctContent}}</v-alert>
          </div>
        </div>
</template>

<script>
  import responseMixin from "./responseMixin";
  import MultipleChoice from "./components/MultipleChoice";
  export default {
    name: "OptionResponse",
    mixins: [responseMixin],
    components:{
            MultipleChoice
    },
    computed: {
      items(){
        return (this.fieldOptions || []).map((opt)=>{
          opt['text']=this.$ta(opt.content_textassetid);
          if(opt.image_assetid){
            opt['url']=this.$asset(opt.image_assetid);
          }
          return opt;
        });
      },
      field(){
        return this.journeyanswers[0].field;
      },
      selectedOption(){
        if(this.singleValue===null || this.singleValue===undefined){
          return null;
        }
        return this.fieldOptions.find((opt)=>opt.value===this.singleValue);
      },
      example(){
        if(!this.selectedOption || this.selectedOption.example_correct===null){
          return null;
        }else{
          return this.selectedOption.example_correct ? 'correct' : 'incorrect';
        }
      },
      correctContent(){
        if(this.selectedOption && this.selectedOption.correctcontent_textassetid){
           return this.$ta(this.selectedOption.correctcontent_textassetid);
        }
        return this.$t('validation.example_correct');
      },
      incorrectContent(){
        if(this.selectedOption && this.selectedOption.incorrectcontent_textassetid){
          return this.$ta(this.selectedOption.incorrectcontent_textassetid);
        }
        return this.$t('validation.example_incorrect');
      }
    }
  }
</script>

<style scoped>

</style>